import { Common, ApiBind } from './common.model';

export class MultiAdConfig extends Common {

  @ApiBind({ column: 'platform_id' })
  platformId: number;

}
